import styled from 'styled-components'

export const TabPanelContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;

  &:focus {
    outline: none;
  }
`
